import {IntegrationsContainerSliceDefaultPrimaryCategoriesItem} from 'prismicio-types'
import {ButtonV2} from 'src/common/ButtonV2'
import {TrackingProps} from 'src/common/helpers'

export const ButtonList = ({
  categories,
  selectedCategory,
  onClick,
  trackingData,
}: {
  categories: IntegrationsContainerSliceDefaultPrimaryCategoriesItem[]
  selectedCategory: number
  onClick: (index: number) => void
  trackingData: Omit<TrackingProps, 'location' | 'event'>
}) => {
  return (
    <ul className="flex max-md:w-full max-md:flex-col max-md:rounded-lg max-md:outline max-md:outline-[1px] max-md:outline-grey-150 md:flex-wrap md:gap-2">
      {categories.map((category, tabIndex) => (
        <li className="cursor-pointer" key={category.category_name! + tabIndex} value={tabIndex}>
          <ButtonV2
            trackingData={{
              ...trackingData,
              location: `category-${category.category_name}-${tabIndex}`,
            }}
            variant={selectedCategory === tabIndex ? 'primary' : 'secondary'}
            className="!h-[38px] !p-3"
            onClick={() => onClick(tabIndex)}
          >
            {category.category_name}
          </ButtonV2>
        </li>
      ))}
    </ul>
  )
}
